import { buildThemeCss } from "../../Helper/ThemeCss";
import { useConfigStore } from "../../Stores/Config";

function CSSInjector() {
  const configStore = useConfigStore();
  const customCSS = configStore.config.customCSS;

  const css = buildThemeCss({
    primaryColor: configStore.getUIColor(),
    backgroundColor: configStore.getBackgroundColor(),
    buttonColor: configStore.getButtonColor(),
    headerColor: configStore.getHeaderColor(),
    headerColor2: configStore.getHeaderColorSecondary("headerColor2"),
    headerColor3: configStore.getHeaderColorSecondary("headerColor3"),
    getBorderRadius: configStore.getBorderRadius,
    auroraColors: configStore.getAuroraColors(),
  });

  return (
    <>
      <style>{css}</style>
      {customCSS && <style>{customCSS}</style>}
    </>
  );
}

export default CSSInjector;
